import { pills } from '../data/pills';
import { getStatus } from './biomarkers';
import type { Biomarker } from '../types/platform';

export function getFlaggedIds(panel: Biomarker[]): string[] {
  return panel.filter((b) => getStatus(b) !== 'optimal').map((b) => b.id);
}

export function getRecommendedPillIds(panel: Biomarker[]): string[] {
  const flagged = getFlaggedIds(panel);
  return pills
    .filter((p) => p.goals.includes('longevity') && p.targets.some((t) => flagged.includes(t)))
    .map((p) => p.id);
}

export function formatAED(value: number): string {
  return `AED ${value.toLocaleString('en-US')}`;
}
